import * as action from './actions';

import * as actionTypes from './actionTypes';

import { InferValueTypes } from 'types/commonTypes';

const initialState = { url: '' };

type ActionType = ReturnType<InferValueTypes<typeof action>>;

const deepLinkReducer = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case actionTypes.GET_DEEP_LINK_SUCCESS:
      return { ...state, url: action.payload };

    case actionTypes.GET_DEEP_LINK_ERROR:
      return { ...state, url: 'error' };

    default:
      return state;
  }
};

export default deepLinkReducer;
